module.exports = __webpack_public_path__ + "static/media/bosyapp-search.b5d7ad3b.jpg";